import { isEmpty, isObject } from 'lodash';
import { ShowMore } from '@ebsco-ui/ebsco-ui';

import { ShowMoreButton } from '@app/components';

import css from './DelimitedList.module.scss';

interface DelimitedListProps<T extends object | string> {
  limit: number;
  items?: T[];
  property?: keyof T;
  delimiter?: string;
}

export const DelimitedList = <T extends object | string>({
  limit,
  items = [],
  property,
  delimiter = '; ',
}: DelimitedListProps<T>) => {
  if (isEmpty(items)) {
    return <span>{'-'}</span>;
  }

  const mappedItems = items.map((item, index) => (
    <li key={index} data-delimiter={delimiter}>
      {isObject(item) && property ? item[property] : item}
    </li>
  ));

  return (
    <ShowMore limit={limit} className={css.showMore}>
      <ul className={css.delimitedList} data-auto="delimited-list">
        <ShowMore.Items>{mappedItems}</ShowMore.Items>
      </ul>
      <ShowMoreButton showMoreLimit={limit} dataLength={items.length} />
    </ShowMore>
  );
};
